import React, { Component } from 'react'
import { MuiDropareaDialog } from '@giscon/ui.mui-droparea'
import Button from '@mui/material/Button';
import DataStore from './../../../stores/DataStore';

/**
 * @class
 *  Für das Hochladen von Dateien
 * @name DropzoneDialogExample
 * @implements {Attribute}
 * */
export default class DropzoneDialogExample extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      files: []
    };
    this.DataStore = DataStore;
  }

  handleClose() {
    this.setState({
      open: false
    });
  }

  getValue() {
    return this.DataStore.attributeValues[this.id].value;
  }

  getValueString() {
    const { value = [] } = DataStore.attributeValues[this.id];
    return ("[" + (value.map(file => file.name).join(", ")) + "]");
  }

  getSummaryDisplay() {
    return (
      <div>{this.getValueString()}</div>
    )
  }


  handleSave(files) {
    //Saving files to state for further use and closing Modal.
    const {
      attribute: { onChange, value = '' } = {},
    } = this.props;
    this.setState({
      files: files,
      open: false
    });
    onChange(files);
  }

  handleOpen() {
    this.setState({
      open: true,
    });
  }

  render() {
    const {
      attribute: {
        id = '',
        name = '',
        attributeOption: {
          acceptedType,
          WrapperDiv,
          Btn = Button,
          Dialog = MuiDropareaDialog,
          ButtonProps = {},
          DialogeProps = {}
        },
        attributeModul,
      } = {},
    } = this.props;
    this.id = id;
    attributeModul.holdedAttribute = this;
    return (
      <div>
        <Btn onClick={this.handleOpen.bind(this)}
          variant="contained"
          color="primary"
          component="span"
          disabled={DataStore.attributeValues[this.id].readOnly}
          {...ButtonProps}>
          {name}
        </Btn>
        <Dialog
          open={this.state.open}
          onSave={this.handleSave.bind(this)}
          acceptedFiles={[acceptedType]}
          //showPreviews={true}
          title={"Dateiupload"}
          maxFileSize={5000000}
          onClose={this.handleClose.bind(this)}
          {...DialogeProps}
        />
      </div>
    );
  }
}